import {extractListPayload} from '../../shared/utils/payload';
import {formatMoneyBR, normalizeFinanceiroDashboard} from '../Financeiro/financeiroUtils';

const getSettledValue = (result) => result?.status === 'fulfilled' ? result.value : null;

const extractSettledList = (result) => {
    const response = getSettledValue(result);
    if (!response) return {items: [], total: 0};
    return extractListPayload(response);
};

const getName = (item = {}) => item?.nome || item?.descricao || item?.chave_ativacao || item?.username || item?.email || 'Registro';

export const normalizePortalDashboard = (responses = {}) => {
    const users = extractSettledList(responses.users);
    const sistemas = extractSettledList(responses.sistemas);
    const licencas = extractSettledList(responses.licencas);
    const financeiroResponse = getSettledValue(responses.financeiro);
    const financeiro = normalizeFinanceiroDashboard(financeiroResponse?.data?.data ?? financeiroResponse?.data ?? {});

    return {
        metrics: [
            {id: 'licencas', title: 'Licenças ativas', value: String(licencas.total), detail: `${sistemas.total} sistemas disponíveis`, tone: 'primary'},
            {id: 'usuarios', title: 'Usuários ativos', value: String(users.total), detail: 'Acessos vinculados ao cliente', tone: 'success'},
            {id: 'faturas', title: 'Faturas pendentes', value: String(financeiro.pendingInvoices), detail: formatMoneyBR(financeiro.openAmount), tone: 'warning'},
            {id: 'status', title: 'Receita mensal', value: formatMoneyBR(financeiro.mrr), detail: `${financeiro.overdueInvoices} faturas vencidas`, tone: 'info'},
        ],
        systems: sistemas.items.map((item) => ({
            id: item?.id,
            name: item?.nome || '-',
            category: item?.descricao || 'Catálogo disponível',
            version: item?.versao || '-',
            modules: Array.isArray(item?.modulos) ? item.modulos.length : 0,
            linkLabel: 'Ver detalhes',
        })).slice(0, 3),
        activities: [
            ...users.items.map((item) => ({
                id: `user-${item?.id || item?.email}`,
                action: 'Acesso habilitado',
                user: getName(item),
                time: item?.updatedAt || item?.atualizado_em || '-',
            })),
            ...licencas.items.map((item) => ({
                id: `lic-${item?.id}`,
                action: `Licença ${item?.status || 'atualizada'}`,
                user: getName(item),
                time: item?.atualizado_em || item?.updated_at || '-',
            })),
        ].slice(0, 5),
        notifications: [
            {id: 1, title: 'Integração ativa', description: `${users.total} usuários e ${licencas.total} licenças carregados da API.`, tone: 'success'},
            {id: 2, title: 'Atenção financeira', description: `${financeiro.overdueInvoices} faturas vencidas identificadas.`, tone: 'warning'},
        ],
        failedSections: Object.entries(responses)
            .filter(([, value]) => value?.status === 'rejected')
            .map(([key]) => key),
    };
};
